<template>
<div class="layout">
    <h-header 
        :title="title" 
        :back="true"
        @loginSuccess="loginSuccess"
    ></h-header>
   <div class="main-content">
        <div class="class-left">
            <div class="class-video">
                <div id="agora_local" class="video">
                    <video id="video"></video>
                </div>
            </div>
            <div class="class-chat">
                <div class="chat-head">讨论区</div>
                <div class="chat-scroll">
                    <div class="chat-scroll-content">
                        <div class="chat-lab" v-for="item in chatItem">
                            {{item.message}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="class-right">
            <video id="screen"></video>
        </div>

        <div class="pro-box" @click.stop="">
            <div class="time">{{secondsShow(curPlay)}}</div>
            <div class="pro-btn" ref="probar"
                @mousedown="proBegin"
                @mousemove.stop="proMove"
                @mouseup.stop="proEnd"
                @mouseleave.stop="proEnd"
            >
                <div class="pro-bg">
                    <div class="pro" :style="'width:'+proLength+'px'"></div>
                </div>
            </div>
            <div class="time">{{secondsShow(maxPlay)}}</div> 
        </div>
   </div>
   
   <div class="share-icon hover" @click="shareLink()">
       <i class="iconfont iconfenxiang"></i>
   </div>
   <share-link v-if="linkShow"
    :url="linkObj.url"
    @closeShareLink="linkShow=false"
   ></share-link>

   <h-footer></h-footer>
</div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import ShareLink from '../components/ShareLink'
import Hls from 'hls.js'

var probar
export default {
    name:'ClassRoom',
    data(){
        return{
            uid:'',
            nickname:'',
            roomid:'',
            title:'',
            obj:{},
            isShare:false,

            chat:'',
            chatItem:[],

            actionList:[],
            actionNum:0,//动作条进展
            actionSection:0,//动作条加载进度打点
            actionSectionMax:500,//断点
            proLength:0,//进度条长度
            curPlay:0,//当前时间秒
            maxPlay:0,//视频长度秒
            startPlay:0,//开始时间戳
            isPlaying:false,

            linkShow:false,
            linkObj:{
                url:'',
                secret:''
            }
        }
    },
    components:{
        'h-header':Header,
        'h-footer':Footer,
        'share-link':ShareLink
    },
    activated(){
        this.$nextTick(()=>{
            probar = this.$refs.probar.getBoundingClientRect()
            console.log(probar)
        })
    },
    methods:{
        //登录完成
        loginSuccess(){
            // if(!this.$store.state.userData.uid) return
            this.obj = this.$route.params.id ? this.$route.params : JSON.parse(localStorage.getItem('ClassRoom'))
            localStorage.setItem('ClassRoom',JSON.stringify(this.obj))
            this.roomid = this.obj.id + ''
            this.title = this.obj.title
            this.getReplayVideo()
        },
        pushChat(obj){
            this.chatItem.push(obj)
            setTimeout(()=>{
                this.calScrollChat()
            },200)
        },
        goBack(){
            this.$router.go(-1)
        },
        getReplayVideo(){
            let that = this
            that.$post(that,{
                url:'getReplayVideo',
                data:{
                    roomId:that.roomid
                },
                success(data){
                    if(location.href.indexOf('localhost') == -1){
                        that.videoContext = that.hlsInit('video',that.splitUrl(data.records[0].replayvideo))
                        that.screenContext = that.hlsInit('screen',that.splitUrl(data.records[1].replayvideo))
                    }
                    that.getReplay()
                }
            })
        },
        hlsInit(type,url){
            var video = document.getElementById(type)
            if (Hls.isSupported()) {
                var hls = new Hls()
                hls.loadSource(url)
                hls.attachMedia(video)
                hls.on(Hls.Events.MANIFEST_PARSED, function() {
                    video.play()
                })
                hls.on(Hls.Events.ERROR, (event, data) => {
                    console.log(event, data);
                    // 监听出错事件
                    console.log("加载失败")
                })
            }else if(video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = url
                video.addEventListener('loadedmetadata', function() {
                    video.play()
                })
            }
            return video
        },
        getReplay(){
            let that = this
            that.$post(that,{
                url:'getReplay',
                data:{
                    roomId:that.roomid
                },
                success(data){
                    let obj = JSON.parse(data)
                    that.actionList = JSON.parse(data).rowRecord
                    that.startPlay = obj.startTime
                    that.curPlay = 0
                    that.maxPlay = (obj.endTime - obj.startTime) / 1000

                    that.doActionList(0)
                    that.timer(1)
                }
            })
        },
        timer(num){
            let length = this.proLength + num * probar.width / this.maxPlay
            if(length < 0){
                this.proLength = 0
            }else if(length > probar.width){
                this.proLength = probar.width
            }else{
                this.proLength = length
            }
            if(this.proLength !== probar.width){
                this.time && clearTimeout(this.time)
                this.time = setTimeout(()=>{
                    this.timer(1)
                },1000)
            }
        },
        doActionList(num,note){
            if(num == 0){
                this.chatItem = []
            }
            this.actionNum = num
            let obj = this.actionList[num]
            
            let diffTime = parseInt((obj.dateline - this.startPlay)/1000 - this.curPlay)
        
            if(diffTime <= 0){
                this.doAction(obj)
                if(this.actionList.length-1>this.actionNum){
                    this.doActionList(num+1,0)
                }
            }else if(diffTime > 0){
                this.actionTime && clearTimeout(this.actionTime)
                this.actionTime = setTimeout(()=>{
                    this.doActionList(num,1)
                },diffTime*1000)
            }
        },
        doAction(obj){
            let that = this
            let data = obj.data
            this.chatItem.push({
                'message':data.msg.message ? data.msg.message : data.msg
            })
        },
        secondsShow(s){
            let m = parseInt(s/60) + ''
            let ss = s - m * 60 + ''
            return (Array(2).join('0') + m).slice(-2) +':'+ (Array(2).join('0') + ss).slice(-2);
        },
        shareLink(){
            this.linkShow = true
            this.linkObj.url = 'id='+this.obj.id+'&token='+this.obj.token
            this.linkObj.token = this.obj.token
        },
        calScrollChat(){
            let over_content = document.getElementsByClassName('chat-scroll')[0]
            let over_height = over_content.offsetHeight
            let content = document.getElementsByClassName('chat-scroll-content')[0]
            let in_height = content.offsetHeight
            if(in_height > over_height){
                over_content.scrollTop = in_height
            }
        },
        proBegin(e){
            this.promove = true
            clearTimeout(this.actionTime)
            clearTimeout(this.time)
            this.contextPause()
            this.proAction(e.clientX)
        },
        proMove(e){
            if(this.promove){
                this.proAction(e.clientX)
            }
        },
        proEnd(e){
            if(this.promove){
                this.promove = false
                this.proAction(e.clientX)
                this.doActionList(0)
                this.contextPlay()
                this.timer(1)
            }
        },
        proAction(clientX){
            let diff = clientX - probar.left
            if(diff < 0){
                this.proLength = 0
            }else if(diff > probar.width){
                this.promove = false
                this.proLength = probar.width
            }else{
                this.proLength = diff
            }
            this.curPlay = parseInt((this.proLength / probar.width) * this.maxPlay)
        },
        contextPlay(){
            console.log('video play')
            if(location.href.indexOf('localhost') == -1){
                console.log('play ok')
                this.videoContext.play()
                this.screenContext.play()
            }
        },
        contextPause(){
            console.log('video pause')
            if(location.href.indexOf('localhost') == -1){
                console.log('pause ok')
                this.videoContext.pause()
                this.screenContext.pause()
            }
        }
    },
    deactivated(){

    },
    watch:{
        proLength(){
            this.curPlay = parseInt(this.proLength / probar.width * this.maxPlay)
        }
    }
}
</script>
<style scoped>
.layout .main-content{
    position:relative;
    width:1200px;
    flex:1;
    display: flex;
    margin:10px auto;
    padding-bottom: 40px;
    overflow: hidden;
}
.class-left{
    width:310px;
    margin-right: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.class-video{
    width:100%;
    height: 260px;
    background: #999;
    margin-bottom: 10px;
}
.class-video .video{
    width:100%;
    height: 100%;
}
.class-chat{
    background: #D1D2D6;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.class-chat .chat-head{
    line-height: 27px;
    color:#fff;
    background: #9A9A9C;
    text-align: left;
    font-size: 18px;
    padding-left: 10px;
}
.class-chat .chat-scroll{
    text-align: left;
    padding-left: 10px;
    color:#333333;
    font-size: 16px;
    flex:1;
    overflow-y: auto;
}
.class-chat .send-box{
    height: 40px;
    line-height: 40px;
    display: flex;
}
.class-chat .send-box .input{
    flex:1;
}
.class-chat .send-box .send-text{
    color:#333;
    margin:0 15px;
}
.class-right{
    position:relative;
    flex: 1;
    height: 100%;
    background: #67686D;
}
.class-right .back-icon{
    position:absolute;
    display: inline-block;
    line-height: 15px;
    border-radius: 15px;
    background: #3E4C5E;
    color: #fff;
    font-size: 12px;
    padding:0 12px;
    right:10px;
    top: 10px;
}
.class-right .back-icon .iconfont{
    margin-right: 7px;
}

.share-icon{
    position:fixed;
    width:70px;
    height: 70px;
    line-height: 70px;
    background: #48596F;
    right: 100px;
    bottom: 100px;
    border-radius: 50%;
    color: #fff;
}
.share-icon .iconfont{
    font-size: 35px;
}
video{
    width:100%;
    height: 100%;
}

.pro-box{
    position:absolute;
    bottom: 80px;
    display: flex;
    width:1200px;
    height: 40px;
    line-height: 40px;
    background:rgba(51,51,51,0.8);
    padding:0 9px;
    margin:0 auto -40px auto;
}
.pro-box .time{
    font-size: 6px;
    color: #fff;
}
.pro-box .pro-btn{
    flex:1;
    height: 100%;
    margin:0 5px;
}
.pro-box .pro-bg{
    flex:1;
    position: relative;
    height: 12px;
    background-color: #0C0C0C;
    margin:14px 0;
    box-shadow:0px 1px 0px 0px rgba(255,255,255,0.05);
}
.pro-box .pro{
    position:absolute;
    width:100px;
    height:12px;
    top: 0;
    left: 0;
    background:linear-gradient(0deg,rgba(119,194,153,1),rgba(38,162,94,1));
    border:1px solid rgba(99, 187, 139, 1);
}
</style>